import { ReactComponent as AddEntitySvg } from "../../assets/images/svgs/addEntity.svg";

const AddEntityIcon = ({ className = "", ...props }) => {
  return (
    <AddEntitySvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default AddEntityIcon;
